module.exports = __webpack_public_path__ + "img/icon-chevron-left.726ae08b.svg";